<div class="sondermind-design-system modal-container">
  <div class="content-area">
    <ng-template [cdkPortalOutlet]="modalPortal"></ng-template>
    @if (saving) {
      <div class="modal-spinner">
        <div class="modal-spinner-container">
          <mat-spinner
            color="primary"
            diameter="88"
            strokeWidth="6"
            [attr.aria-label]="data.spinnerText"
          ></mat-spinner>
          <span class="modal-spinner-text">{{ data.spinnerText }}</span>
        </div>
      </div>
    }
  </div>

  @if (data.actions.length > 0) {
    <mat-dialog-actions>
      <div sondermind-button-row>
        @for (button of data.actions; track button.style) {
          @switch (button.style) {
            @case ('primary') {
              <iris-button
                data-test="save-button"
                [disabled]="disableButtons || button.disabled"
                (click)="button.onClick.next($event)"
              >
                {{button.text}}
              </iris-button>
            }
            @case ('secondary') {
              <iris-button
                [type]="irisButtonTypes.SECONDARY"
                [disabled]="disableButtons || button.disabled"
                (click)="button.onClick.next($event)"
              >
                {{button.text}}
              </iris-button>
            }
            @case ('tertiary') {
              <iris-button
                [type]="irisButtonTypes.TERTIARY"
                [disabled]="disableButtons || button.disabled"
                (click)="button.onClick.next($event)"
              >
                {{button.text}}
              </iris-button>
            }
            @case ('default') {
              <iris-button
                [type]="irisButtonTypes.SECONDARY"
                [disabled]="disableButtons || button.disabled"
                (click)="button.onClick.next($event)"
              >
                {{button.text}}
              </iris-button>
            }
          }
        }
      </div>
    </mat-dialog-actions>
  }
</div>
